import { render, staticRenderFns } from "./Introduction_2.vue?vue&type=template&id=5304e7a9&scoped=true&"
var script = {}
import style0 from "./Introduction_2.vue?vue&type=style&index=0&id=5304e7a9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5304e7a9",
  null
  
)

component.options.__file = "Introduction_2.vue"
export default component.exports